import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=7efef73b&scoped=true&"
import script from "./CreateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomer.vue?vue&type=style&index=0&id=7efef73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efef73b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
